import React from 'react'
import { useNavigate } from 'react-router';
import BinTransitKanbanView from '../../../components/Comman/BinTransitView/BinTransitKanbanView';

const GSM_ViewBinTransitPage = () => {
    const navigate = useNavigate();

    const handleArrowClick = () => {
        navigate("/gsm/dashboard/transit");
    };

  return (
    <BinTransitKanbanView handleArrowClick={handleArrowClick} />
  )
}

export default GSM_ViewBinTransitPage